define('presentation/settings/integrations/viewModels/addClioGrowTokenModalViewModel',[
    'businessServices/state/modelStateObserver',
    'common/promises/promiseFactory',
    'presentation/settings/integrations/facades/addClioGrowTokenModalFacade',
    'presentation/settings/integrations/validators/addClioGrowTokenModalValidator'
], function() {
    return function() {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const ModelStateObserverConstructor = require('businessServices/state/modelStateObserver');

        const _i18n = require('i18next');

        let _facade = null;
        let _validator = null;

        self.modelStateObserver = null;
        self.clioGrowToken = ko.observable('').extend({observeState: true});
        self.isCompositionComplete = ko.observable(false);
        self.closeButtonI18nKey = ko.observable('cancel');
        self.submitButtonText = ko.pureComputed(() => _i18n.t(`addClioGrowTokenModal:save`));

        self.validate = () => _validator.validate();

        self.submitAction = () => {
            return _promiseFactory.deferWithMinimumWait((promise) => {
                _validator.validate()
                    .fail(promise.reject)
                    .done((isValid) => {
                        if (isValid) {
                            _facade.saveClioGrowToken(self.clioGrowToken())
                                .fail(promise.reject)
                                .done(() => {
                                    promise.resolve();
                                });
                        } else {
                            promise.resolve({ isValid: false });
                        }
                    });
            });
        };

        self.compositionComplete = () => {
            self.isCompositionComplete(true);
        };

        self.activate = () => {
            const FacadeConstructor = require('presentation/settings/integrations/facades/addClioGrowTokenModalFacade');
            _facade = new FacadeConstructor();
            _facade.init(_promiseFactory);

            const ValidatorConstructor = require('presentation/settings/integrations/validators/addClioGrowTokenModalValidator');
            _validator = new ValidatorConstructor();

            return _initialize();
        };

        const _initialize = () => {
            self.modelStateObserver = new ModelStateObserverConstructor(self, true);

            _validator.registerViewModel(self, _facade);

            return _promiseFactory.wait();
        };
    };
});

